import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { FaMapPin, FaRupeeSign, FaShoppingBag } from "react-icons/fa";
import Select from "react-select";
import { backendApi } from "../../api/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Switch from "react-switch";
import { useNavigate } from "react-router-dom";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FiCalendar, FiMapPin } from "react-icons/fi";
import { MdOutlineCurrencyRupee } from "react-icons/md";
import "react-tabs/style/react-tabs.css";
import {
  FaAddressBook,
  FaAward,
  FaClock,
  FaEnvelope,
  FaEdit,
  FaMobile,
  FaSearchLocation,
} from "react-icons/fa";
import ScheduleInterviewPopup from "../schedule/scheduleInterviewPopup";
import ShortlistTable from "./assignRecruiterComponents/shortlistTable";
import ArchiveListTable from "./assignRecruiterComponents/archivedTable";
import AppliedListTable from "./assignRecruiterComponents/appliedTable";
import HiredTable from "./assignRecruiterComponents/hiredTable";
import { useSelector } from "../../components/hooks/hooks.js";
import { BsFillCalendar2CheckFill } from "react-icons/bs";
import ReactDatePicker from "react-datepicker";
import { FaPencil } from "react-icons/fa6";
import OnHoldTable from "./assignRecruiterComponents/OnHoldTable";
import RejectTable from "./assignRecruiterComponents/RejectTable";
import RecruitTable from "./assignRecruiterComponents/RecruitTable";
function AssignRecruiter() {
  const location = useLocation();
  const { props, is_active } = location.state;
  console.log(is_active, "is_active_value");

  const { userDetails, userData, userId, siteId } = useSelector(
    (state) => state.login
  );
  const [candidate, setCandidate] = useState({});
  const [menuClick, setMenuClick] = useState(false);
  const [recruiter, setRecruiter] = useState("");
  const [manager, setManager] = useState("");
  const [comments, setComments] = useState("");
  const [oldComments, setOldComments] = useState("");
  const [recruiters, setRecruiters] = useState([]);
  const [managers, setManagers] = useState([]);
  const [assignedRecruiters, setAssignedRecruiters] = useState([]);
  const [assignedManagers, setAssignedManagers] = useState([]);
  const navigate = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [candidateId, setCandidateId] = useState("");
  const [openings, setOpenings] = useState("");
  const [scheduleInterview, setScheduleInterview] = useState(false);
  const [opening, setOpening] = useState("");
  const [archiveList, setArchiveList] = useState([]);
  const [appliedList, setAppliedList] = useState([]);
  const [hiredList, setHiredList] = useState([]);
  const [userList, setuserList] = useState([]);
  const [statusDetails, setStatusDetails] = useState([]);
  const [isEditList, setIsEditList] = useState([
    {
      key: "summary",
      isEdit: false,
    },
    {
      key: "description",
      isEdit: false,
    },
    {
      key: "projectName",
      isEdit: false,
    },
    {
      key: "closingDate",
      isEdit: false,
    },
    {
      key: "status",
      isEdit: false,
    },
    {
      key: "experience",
      isEdit: false,
    },
    {
      key: "salary",
      isEdit: false,
    },
    {
      key: "location",
      isEdit: false,
    },
    {
      key: "noOfPositions",
      isEdit: false,
    },
  ]);
  const [tempValues, setTempValues] = useState({
    summary: "",
    description: "",
    tempProjectName: "",
    tempClosingDate: null,
    tempExperience: 0,
    tempPackageVal: 0,
    tempLocation: "",
    tempOpenings: 0,
    tempActive: 0,
    tempStatus: ""
  });
  // const [tempProjectName, setTempProjectName] = useState("");
  // const [tempClosingDate, setTempClosingDate] = useState(null);
  // const [tempExperience, setTempExperience] = useState(0);
  // const [tempPackageVal, setTempPackageVal] = useState(0);
  // const [tempLocation, setTempLocation] = useState("");
  // const [tempOpenings, setTempOpenings] = useState(0);
  var tempProjectName = "",
    tempClosingDate = null,
    tempExperience = 0,
    tempPackageVal = 0,
    tempLocation = "",
    tempOpenings = 0;

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("ProcessingMenu").classList.add("active");
    }, 500);
    initialValues();
    assignInit();
    getShortList();
    getArchivedList();
    getAppliedList();
    getHiredList();
    onHoldcandidateList();
    RejectListcandidateList();
    RecruitListListcandidateList();
  }, []);
  useEffect(() => {
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [tempValues]);
  const keyDownHandler = (event) => {
    if (event.key === "Escape") {
      // event.preventDefault();
      setIsEditList(
        isEditList.map((obj) => ({
          ...obj,
          isEdit: false,
        }))
      );
      setCandidate((props) => ({
        ...props,
        summary: tempValues.summary,
        description: tempValues.description,
        project_name: tempValues.tempProjectName,
        end_date: tempValues.tempClosingDate,
        experiance: tempValues.tempExperience,
        salary: tempValues.tempPackageVal,
        location: tempValues.tempLocation,
        no_of_position: tempValues.tempOpenings,
        is_active: tempValues.is_active,
        status: tempValues.tempStatus
      }));
    }
  };
  const initialValues = () => {
    setCandidate(location.state.props);
  };
  const getArchivedList = () => {
    const apiReq = {
      functionName: "ArchiveList",
      job_opening_id: location.state.props.id,
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(apiReq).then((data) => {
      setArchiveList(data.dataset);
      console.log(data.dataset, "dataset of archived data");

    });
  };
  const getHiredList = () => {
    const apiReq = {
      functionName: "hiredList",
      job_opening_id: location.state.props.id,
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(apiReq).then((data) => {
      setHiredList(data.dataset);
    });
  };
  const getAppliedList = () => {
    const apiReq = {
      functionName: "appliedList",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: location.state.props.id,
    };
    backendApi(apiReq).then((data) => {
      setAppliedList(data.dataset);
    });
  };

  //ON HOLD LIST API FETCH

  const [OnholdList, setOnholdList] = useState([])
  const onHoldcandidateList = () => {
    const apiReq = {
      functionName: "onHoldcandidateList",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: location.state.props.id,
      status_value: "On Hold"
    };
    backendApi(apiReq).then((data) => {
      setOnholdList(data.dataset);
      console.log("On Hold", data);

    });
  };

  //REJECT LIST API FETCH

  const [RejectList, setRejectList] = useState([])
  const RejectListcandidateList = () => {
    const apiReq = {
      functionName: "onHoldcandidateList",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: location.state.props.id,
      status_value: "Reject"
    };
    backendApi(apiReq).then((data) => {
      console.log("Reject", data);
      setRejectList(data.dataset);
    });
  };

  //RECRUIT LIST API FETCH

  const [RecruitList, setRecruitList] = useState([])
  const RecruitListListcandidateList = () => {
    const apiReq = {
      functionName: "onHoldcandidateList",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: location.state.props.id,
      status_value: "Recruit"
    };
    backendApi(apiReq).then((data) => {
      console.log("Recruit", data);
      setRecruitList(data.dataset);
    });
  };


  const changeActive = (event, candidate) => {
    // setOpenings(
    //   openings.map((obj) => {
    //     if (candidate.id === obj.id) {
    //       return {
    //         ...obj,
    //         is_active: event === true ? 1 : 0,
    //       };
    //     }
    //     return obj;
    //   })
    // );
    var req = {
      functionName: "job_opening_active_deactive",
      job_opening_id: candidate.id,
      is_active: event,
    };
    backendApi(req).then((response) => {
      if (response.success !== 1) {
        console.error("error while fetching openings");
        return false;
      } else {
        setCandidate((obj) => ({
          ...obj,
          is_active: event === true ? 1 : 0,
        }));
        assignInit();
        toast.success("Status Changed", { containerId: "D" });
      }
    });
  };

  const navigateToOtherPage = (value) => {
    // const yourProp = value;
    navigate(`/process`, {
      state: {
        props: value.id,
        from: 'assignRecruiter'
      },
    });
  };

  const viewResumes = (value) => {
    const yourProp = value;
    navigate(`/viewMatchingRecruiters`, {
      state: {
        props: yourProp,
        from: 'assignrecruiters'
      },
    });
  };

  const assignInit = () => {
    var req = {
      functionName: "getJobOpeningDetailsById",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: location.state.props.id,
    };
    backendApi(req).then(async (response) => {
      if (response.success == "1") {
        const filtered = response.recruiter_list.filter(
          (recruiter) =>
            !response.recruiter_job_opening.some(
              (assRec) => assRec.id === recruiter.id
            )
        );
        let managers = await getUserList();
        const filteredM = managers.filter(
          (recruiter) =>
            !response.managers.some((assRec) => assRec.id === recruiter.id)
        );
        setManagers(filteredM);
        setRecruiters(filtered);
        setComments(response.JobOpeningData[0].comments);
        setOldComments(response.JobOpeningData[0].comments);
        setAssignedRecruiters(response.recruiter_job_opening);
        setAssignedManagers(response.managers);
        setStatusDetails(response.statusDetails);
        console.log(response.JobOpeningData, "response.JobOpeningData");

        setTempValues((props) => ({
          tempsummary: response.JobOpeningData[0].summary,
          tempdescription: response.JobOpeningData[0].description,
          tempProjectName: response.JobOpeningData[0].project_name,
          tempClosingDate: response.JobOpeningData[0].end_date,
          tempExperience: response.JobOpeningData[0].experiance,
          tempPackageVal: response.JobOpeningData[0].salary,
          tempLocation: response.JobOpeningData[0].location,
          tempOpenings: response.JobOpeningData[0].no_of_position,
          tempActive: response.JobOpeningData[0].is_active,
          tempStatus: response.JobOpeningData[0].status
        }));
        // setCandidate({
        //   is_active: response.JobOpeningData[0].is_active
        // })
        // tempProjectName = response.JobOpeningData[0].project_name;
        // tempClosingDate = response.JobOpeningData[0].end_date;
        // tempExperience = response.JobOpeningData[0].experiance;
        // tempPackageVal = response.JobOpeningData[0].salary;
        // tempLocation = response.JobOpeningData[0].location;
        // tempOpenings = response.JobOpeningData[0].no_of_position;
      } else {
        console.error("error in api");
        return false;
      }
    });
  };
  const getUserList = () => {
    return new Promise((resolve, reject) => {
      const api = {
        functionName: "userListing",
        site_id: userDetails[0].site_id,
      };
      backendApi(api).then((response) => {
        if (response.success === "1") {
          setuserList(response.dataSet)
          let array = response.dataSet.map((m) => ({
            ...m,
            label: `${m.first_name} ${m.last_name}`,
            value: m.id,
          }));
          resolve(array);
          return array;
          // getRequirementOpenings();
        } else {
          toast.warn("Something went wrong getting userList", {
            containerId: "D",
          });
          reject([]);
          return [];
        }
      });
    });
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }

  const handleSave = () => {
    if (recruiter === "") {
      toast.warn("Please select a recruiter", { containerId: "D" });
      return false;
    }
    var req = {
      functionName: "AddRecruiter",
      site_id: localStorage.getItem("siteId"),
      recruiter_id: recruiter,
      job_opening_id: candidate.id,
      created_by: localStorage.getItem("userId"),
    };
    backendApi(req).then((response) => {
      if (response.success == "1") {
        toast.success("Recruiter assigned successfully", { containerId: "D" });
        setRecruiter("");
        assignInit();
      } else {
        console.error("error in api");
        return false;
      }
    });
  };
  const handleManagerSave = () => {
    if (manager === "") {
      toast.warn("Please select a recruiter", { containerId: "D" });
      return false;
    }
    var req = {
      functionName: "reportingManagersSave",
      job_opening_id: candidate.id,
      sec_user_id: manager,
    };
    backendApi(req).then((response) => {
      if (response.success == "1") {
        toast.success("Manager assigned successfully", { containerId: "D" });
        setManager("");
        assignInit();
      } else {
        console.error("error in api");
        return false;
      }
    });
  };

  const handleRemove = (id, checked) => {
    let status;
    if (checked == false) {
      status = "0";
    } else {
      status = "1";
    }
    var req = {
      functionName: "remove_Recruiter",
      recruiter_id: id,
      job_opening_id: candidate.id,
      is_active: status,
    };
    backendApi(req).then((response) => {
      if (response.success == "1") {
        toast.success("Recruiter removed successfully", { containerId: "D" });
        assignInit();
      } else {
        return false;
      }
    });
  };
  const handleManagerRemove = (id, checked) => {
    let status;
    if (checked == false) {
      status = "0";
    } else {
      status = "1";
    }
    var req = {
      functionName: "reportingManagersActiveDeactive",
      reportingManagers_id: id,
      is_active: String(Number(checked)),
    };
    backendApi(req).then((response) => {
      if (response.success == "1") {
        toast.success("Manager removed successfully", { containerId: "D" });
        assignInit();
      } else {
        console.error("error in api");
        return false;
      }
    });
  };

  const getShortList = () => {
    var req = {
      functionName: "shortListedList",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
      job_opening_id: location.state.props.id,
    };
    backendApi(req).then((response) => {
      if (response.success == 1) {
        setCandidates(response.dataset);
        console.log(response.dataset, "shortlist_candidates");

      } else {
        console.error("error while fetching shortLists");
        return false;
      }
    });
  };

  const goToEditPage = (candidateId) => {
    navigate(`/candidateprofile/${candidateId}`);
  };

  const candidateInterview = (id) => {
    setCandidateId(id);
    setScheduleInterview(true);
    setOpening(candidate);
  };

  const closePopup = () => {
    setScheduleInterview(false);
  };
  const navigateBulkUpload = (candidate) => {
    navigate("/openings/uploadResumes", {
      state: {
        opening: candidate,
        parameter: location.state.props,
      },
    });
  };
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  const updateComments = () => {
    const api = {
      functionName: "job_opening_comments_update",
      job_opening_id: candidate.id,
      comments: comments.replace(/['"]/g, "\\$&"),
    };
    backendApi(api).then((response) => {
      if (response.success !== 1) {
        toast.error("Something went wrong in updating comments", {
          containerId: "D",
        });
        return false;
      }
      setOldComments(comments);
      toast.success("Comments saved successfully", { containerId: "D" });
    });
  };
  const handleEditMode = (key) => {
    setIsEditList(
      isEditList.map((obj) => {
        if (obj.key === key) {
          return {
            ...obj,
            isEdit: true,
          };
        }
        return obj;
      })
    );
  };
  const handleCancelEdit = (key) => {
    setIsEditList(
      isEditList.map((obj) => {
        if (obj.key === key) {
          return {
            ...obj,
            isEdit: false,
          };
        }
        return obj;
      })
    );

    setCandidate((props) => ({
      ...props,
      ...key === "summary" && { summary: tempValues.tempsummary },
      ...key === "description" && { description: tempValues.tempdescription },
      ...(key === "projectName" && {
        project_name: tempValues.tempProjectName,
      }),
      ...(key === "closingDate" && { end_date: tempValues.tempClosingDate }),
      ...(key === "experience" && { experiance: tempValues.tempExperience }),
      ...(key === "salary" && { salary: tempValues.tempPackageVal }),
      ...(key === "location" && { location: tempValues.tempLocation }),
      ...(key === "noOfPositions" && {
        no_of_position: tempValues.tempOpenings,
      }),
      ...(key === "status" && { status: tempValues.tempStatus }),
    }));
  };


  const updateDetails = (key) => {
    const api = {
      functionName: "updateJobOpeningDetails",
      job_opening_id: candidate.id,
      ...(key === "summary" && {
        field_name: "summary",
        field_value: candidate.summary,
      }),
      ...(key === "description" && {
        field_name: "description",
        field_value: candidate.description,
      }),
      ...(key === "projectName" && {
        field_name: "project_name",
        field_value: candidate.project_name,
      }),
      ...(key === "closingDate" && {
        field_name: "end_date",
        field_value: candidate.end_date,
      }),
      ...(key === "experience" && {
        field_name: "experiance",
        field_value: candidate.experiance,
      }),
      ...(key === "salary" && {
        field_name: "salary",
        field_value: candidate.salary,
      }),
      ...(key === "location" && {
        field_name: "location",
        field_value: candidate.location,
      }),
      ...(key === "noOfPositions" && {
        field_name: "no_of_position",
        field_value: candidate.no_of_position,
      }),
      ...(key === "status" && {
        field_name: "status",
        field_value: candidate.status,
      }),
    };
    backendApi(api).then((response) => {
      if (response.success === 1) {
        setIsEditList(
          isEditList.map((obj) => {
            if (obj.key === key) {
              return {
                ...obj,
                isEdit: false,
              };
            }
            return obj;
          })
        );
        toast.success("Saved Successfully", { containerId: "D" });
      } else {
        toast.error("Something went wrong", { containerId: "D" });
      }
    });
  };
  useEffect(() => { }, [tempProjectName]);
  const handleBack = () => {
    navigate('/initialProcess');
  };
  useEffect(() => {
    assignInit()
  }, [isEditList])

  const [StatusValues, setStatusValues] = useState([]);
  useEffect(() => {
    ShortListData();
  }, []);

  const ShortListData = () => {
    const req = {
      functionName: "rec_StatusShortList",
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          console.log(response.data, "rec_StatusShortList");
          setStatusValues(response.dataSet)
        } else {
          console.error("Backend responded with an error", response);
        }
      })
      .catch((error) => {
        console.error("An error occurred during the API call:", error);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Dashboard"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container">
            <ToastContainer
              enableMultiContainer
              containerId={"D"}
              position="bottom-right"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
            <div className="card main-card">
              <div className="card-body">
                <div className="row">
                  {statusDetails.map((obj) => {
                    return (
                      <div className="col-xxl-2 col-lg-2 col-md-6 padding-left-right-change">
                        <div className="card main-card-box dashboard-boxes">
                          <div className="card-body">
                            <div className="box_splite box_split_sm">
                              <div className="left_splite">
                                <h3 className="box-head">
                                  {obj.category_type}
                                </h3>
                              </div>
                              <div className="right_splite">{obj.cnt}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="crnRes cards-crnRes">
                      <div className="row">
                        <div className="col-md-8">
                          <h4 className="job-view-header">
                            {/* {candidate.summary} */}
                            {isEditList.filter(
                              (obj) => obj.key === "summary"
                            )[0].isEdit === false ? (
                              <>
                                <span>
                                  {tempValues.tempsummary
                                    ? tempValues.tempsummary
                                    : " Not Available"}
                                </span>
                                <FaPencil
                                  style={{ color: "red", marginLeft: "8px" }}
                                  onClick={() => handleEditMode("summary")}
                                />
                              </>
                            ) : (
                              <>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Project Name"
                                  value={candidate.summary}
                                  onChange={(e) =>
                                    setCandidate((props) => ({
                                      ...props,
                                      summary: e.target.value,
                                    }))
                                  }
                                />
                                <div style={{ marginTop: "8px" }}>
                                  <button
                                    disabled={is_active === 0}
                                    onClick={() => updateDetails("summary")}
                                  >
                                    Save
                                  </button>
                                  <button

                                    style={{ marginLeft: "8px" }}
                                    onClick={() =>
                                      handleCancelEdit("summary")
                                    }
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </>
                            )}

                          </h4>
                          <p className="font-Medium mb-4">
                            {/* {candidate.description} */}
                            {isEditList.filter(
                              (obj) => obj.key === "description"
                            )[0].isEdit === false ? (
                              <>
                                <span>
                                  {tempValues.tempdescription
                                    ? tempValues.tempdescription
                                    : " Not Available"}
                                </span>
                                <FaPencil
                                  style={{ color: "red", marginLeft: "8px" }}
                                  onClick={() => handleEditMode("description")}
                                />
                              </>
                            ) : (
                              <>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Project Name"
                                  value={candidate.description}
                                  onChange={(e) =>
                                    setCandidate((props) => ({
                                      ...props,
                                      description: e.target.value,
                                    }))
                                  }
                                />
                                <div style={{ marginTop: "8px" }}>
                                  <button
                                    disabled={is_active === 0}
                                    onClick={() => updateDetails("description")}
                                  >
                                    Save
                                  </button>
                                  <button

                                    style={{ marginLeft: "8px" }}
                                    onClick={() =>
                                      handleCancelEdit("description")
                                    }
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </>
                            )}

                          </p>
                          <p className="font-Medium mb-4">
                            Project:{" "}
                            {isEditList.filter(
                              (obj) => obj.key === "projectName"
                            )[0].isEdit === false ? (
                              <>
                                <span>
                                  {tempValues.tempProjectName
                                    ? tempValues.tempProjectName
                                    : " Not Available"}
                                </span>
                                <FaPencil
                                  style={{ color: "red", marginLeft: "8px" }}
                                  onClick={() => handleEditMode("projectName")}
                                />
                              </>
                            ) : (
                              <>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Project Name"
                                  value={candidate.project_name}
                                  onChange={(e) =>
                                    setCandidate((props) => ({
                                      ...props,
                                      project_name: e.target.value,
                                    }))
                                  }
                                />
                                <div style={{ marginTop: "8px" }}>
                                  <button
                                    disabled={is_active === 0}
                                    onClick={() => updateDetails("projectName")}
                                  >
                                    Save
                                  </button>
                                  <button

                                    style={{ marginLeft: "8px" }}
                                    onClick={() =>
                                      handleCancelEdit("projectName")
                                    }
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </>
                            )}
                          </p>
                          <div className="flex-result">
                            <div className="flex-sub-divv">
                              <span className="label-text">
                                <FiCalendar
                                  className="me-1"
                                  title="Starting Date"
                                />
                              </span>
                              <span className="font-Medium ">
                                {formatDate(candidate.start_date)}
                              </span>
                            </div>
                            <div className="flex-sub-divv">
                              <span className="label-text">
                                <BsFillCalendar2CheckFill
                                  className="me-1"
                                  title="Closing Date"
                                />
                              </span>
                              {isEditList.filter(
                                (obj) => obj.key === "closingDate"
                              )[0].isEdit === false ? (
                                <>
                                  <span
                                    className="font-Medium "
                                    onClick={() =>
                                      handleEditMode("closingDate")
                                    }
                                  >
                                    {formatDate(candidate.end_date)}
                                  </span>
                                  <FaPencil
                                    style={{ color: "red", marginLeft: "8px" }}
                                    onClick={() =>
                                      handleEditMode("closingDate")
                                    }
                                  />
                                </>
                              ) : (
                                <>
                                  <ReactDatePicker
                                    className="form-control"
                                    placeholder="Enter Closing Date"
                                    minDate={
                                      new Date(
                                        new Date(candidate?.start_date).setDate(
                                          new Date(
                                            candidate?.start_date
                                          ).getDate() + 1
                                        )
                                      )
                                    }
                                    selected={new Date(candidate.end_date)}
                                    onChange={(e) =>
                                      setCandidate((props) => ({
                                        ...props,
                                        end_date: e,
                                      }))
                                    }
                                  />
                                  <button
                                    disabled={is_active === 0}
                                    onClick={() => updateDetails("closingDate")}
                                  >
                                    Save
                                  </button>
                                  <button

                                    onClick={() =>
                                      handleCancelEdit("closingDate")
                                    }
                                  >
                                    Cancel
                                  </button>
                                </>
                              )}
                            </div>
                            {/* <div className="flex-sub-divv">
                              <span className="label-text">Status : </span>
                              <span className="font-Medium ">
                                {candidate.status
                                  ? candidate.status
                                  : " Not Available"}
                              </span>
                            </div> */}

                            <div className="flex-sub-divv">
                              <span className="label-text">
                                <FaShoppingBag className="me-1" />
                              </span>
                              {isEditList.filter(
                                (obj) => obj.key === "status"
                              )[0].isEdit === false ? (
                                <>
                                  <span className="">
                                    {" "}
                                    {tempValues.tempStatus
                                      ? tempValues.tempStatus
                                      : " Not Available"}

                                  </span>
                                  <FaPencil
                                    style={{ color: "red", marginLeft: "8px" }}
                                    onClick={() => handleEditMode("status")}
                                  />
                                </>
                              ) : (
                                <>
                                  <select
                                    className="form-control"
                                    value={candidate.status}
                                    onChange={(e) =>
                                      setCandidate((props) => ({
                                        ...props,
                                        status: e.target.value,
                                      }))
                                    }
                                  >
                                    <option value="Open">Open</option>
                                    <option value="Closed">Closed</option>
                                    <option value="On Hold">On Hold</option>
                                    <option value="Archived">Archived</option>
                                  </select>
                                  <button disabled={is_active === 0} onClick={() => updateDetails("status")}>Save</button>
                                  <button onClick={() => handleCancelEdit("status")}>Cancel</button>

                                </>
                              )}
                            </div>


                            <div className="flex-sub-divv">
                              <span className="label-text">
                                <FaShoppingBag className="me-1" />
                              </span>
                              {isEditList.filter(
                                (obj) => obj.key === "experience"
                              )[0].isEdit === false ? (
                                <>
                                  <span className="">
                                    {" "}
                                    {tempValues.tempExperience
                                      ? tempValues.tempExperience
                                      : 0}{" "}
                                    Years
                                  </span>
                                  <FaPencil
                                    style={{ color: "red", marginLeft: "8px" }}
                                    onClick={() => handleEditMode("experience")}
                                  />
                                </>
                              ) : (
                                <>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Experience"
                                    value={candidate.experiance}
                                    onChange={(e) =>
                                      setCandidate((props) => ({
                                        ...props,
                                        experiance: e.target.value,
                                      }))
                                    }
                                  />
                                  <button
                                    disabled={is_active === 0}
                                    onClick={() => updateDetails("experience")}
                                  >
                                    Save
                                  </button>
                                  <button

                                    onClick={() =>
                                      handleCancelEdit("experience")
                                    }
                                  >
                                    Cancel
                                  </button>
                                </>
                              )}
                            </div>

                            <div className="flex-sub-divv">
                              <span className="label-text">
                                <MdOutlineCurrencyRupee className="me-1" />
                              </span>
                              {/* <span className="font-Medium ">
                                {" "}
                                {candidate.salary ? candidate.salary : 0}
                              </span> */}

                              {isEditList.filter(
                                (obj) => obj.key === "salary"
                              )[0].isEdit === false ? (
                                <>
                                  <span className="font-Medium ">
                                    {" "}
                                    {tempValues.tempPackageVal
                                      ? tempValues.tempPackageVal
                                      : 0}{" "}
                                  </span>
                                  <FaPencil
                                    style={{ color: "red", marginLeft: "8px" }}
                                    onClick={() => handleEditMode("salary")}
                                  />
                                </>
                              ) : (
                                <>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Salary"
                                    value={candidate.salary}
                                    onChange={(e) =>
                                      setCandidate((props) => ({
                                        ...props,
                                        salary: e.target.value,
                                      }))
                                    }
                                  />
                                  <button
                                    disabled={is_active === 0}
                                    onClick={() => updateDetails("salary")}
                                  >
                                    Save
                                  </button>
                                  <button

                                    onClick={() => handleCancelEdit("salary")}
                                  >
                                    Cancel
                                  </button>
                                </>
                              )}
                            </div>
                            <div className="flex-sub-divv">
                              <span className="label-text">
                                <FiMapPin className="me-1" />
                              </span>

                              {isEditList.filter(
                                (obj) => obj.key === "location"
                              )[0].isEdit === false ? (
                                <>
                                  <span className="font-Medium ">
                                    {" "}
                                    {candidate.location
                                      ? candidate.location
                                      : "Not Available"}{" "}
                                  </span>
                                  <FaPencil
                                    style={{ color: "red", marginLeft: "8px" }}
                                    onClick={() => handleEditMode("location")}
                                  />
                                </>
                              ) : (
                                <>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Location"
                                    value={candidate.location}
                                    onChange={(e) =>
                                      setCandidate((props) => ({
                                        ...props,
                                        location: e.target.value,
                                      }))
                                    }
                                  />
                                  <button
                                    disabled={is_active === 0}
                                    onClick={() => updateDetails("location")}
                                  >
                                    Save
                                  </button>
                                  <button

                                    onClick={() => handleCancelEdit("location")}
                                  >
                                    Cancel
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <button
                            disabled={is_active === 0}
                            className="btn btn-btn1 btn-btn bg-success w-100 mb-3"
                            onClick={() => navigateToOtherPage(candidate)}
                          >
                            Prepare JD
                          </button>
                          <button
                            disabled={is_active === 0}
                            className="btn btn-btn1 btn-btn bg-warning w-100 mb-3"
                            onClick={() => viewResumes(candidate)}
                          >
                            Matching CVs
                          </button>
                          <button
                            disabled={is_active === 0}
                            className="btn btn-btn1 btn-btn bg-primary w-100 mb-3"
                            onClick={() => navigateBulkUpload(candidate)}
                          >
                            Archive
                          </button>
                        </div>
                      </div>
                      <div className="row mb-3 mt-3">
                        <div className="col-md-9">
                          <div className="flex-result">
                            <div className="flex-sub-divv">
                              <span className="label-text">
                                {" "}
                                No of Positions :{" "}
                              </span>

                              {isEditList.filter(
                                (obj) => obj.key === "noOfPositions"
                              )[0].isEdit === false ? (
                                <>
                                  <span className="font-Medium ">
                                    {candidate.no_of_position
                                      ? candidate.no_of_position
                                      : 0}{" "}
                                    Nos.
                                  </span>
                                  <FaPencil
                                    style={{ color: "red", marginLeft: "8px" }}
                                    onClick={() =>
                                      handleEditMode("noOfPositions")
                                    }
                                  />
                                </>
                              ) : (
                                <>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Location"
                                    value={candidate.no_of_position}
                                    onChange={(e) =>
                                      setCandidate((props) => ({
                                        ...props,
                                        no_of_position: e.target.value,
                                      }))
                                    }
                                  />
                                  <button
                                    disabled={is_active === 0}
                                    onClick={() =>
                                      updateDetails("noOfPositions")
                                    }
                                  >
                                    Save
                                  </button>
                                  <button

                                    onClick={() =>
                                      handleCancelEdit("noOfPositions")
                                    }
                                  >
                                    Cancel
                                  </button>
                                </>
                              )}
                            </div>
                            <div className="flex-sub-divv">
                              <span className="label-text">Posted on : </span>
                              <span className="font-Medium ">
                                {formatDateToCustomFormat(candidate.created_on)}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3 dEnd">
                          <Switch
                            className="switch_case"
                            handleDiameter={16}
                            height={18}
                            width={40}
                            checked={tempValues.tempActive === 1 ? true : false}
                            onChange={(checked) => {
                              changeActive(checked, candidate);
                            }}
                            disabled={is_active === 0}
                          />
                        </div>
                      </div>
                      <textarea
                        rows={4}
                        placeholder="Comments"
                        onChange={(e) => setComments(e.target.value)}
                        value={comments}
                        className="form-control"
                      />
                      {oldComments !== comments && (
                        <div className="text-end mt-2">
                          <button
                            disabled={is_active === 0}
                            style={{ minWidth: "120px" }}
                            className="btn btn-btn1 btn-btn bg-primary mb-3"
                            onClick={() => updateComments()}
                          >
                            Save
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="crnRes cards-crnRes">
                      <div className="crmPost border-0">
                        <Tabs
                        // selectedIndex={tabIndex}
                        // onSelect={(index) => setTabIndex(index)}
                        >
                          <TabList>
                            <Tab>Recruiters</Tab>
                            <Tab>Managers</Tab>
                          </TabList>
                          <TabPanel>
                            <div className="row">
                              <div className="col-md-12">
                                <label className="form-label">
                                  Recruiters :{" "}
                                </label>
                                <select
                                  className="form-control col-md-7"
                                  style={{ fontSize: "14px" }}
                                  onChange={(e) => setRecruiter(e.target.value)}
                                  value={recruiter}
                                >
                                  <option value="">Select a Recruiter</option>
                                  {recruiters.map((rec) => (
                                    <option key={rec.id} value={rec.id}>
                                      {rec.first_name + " " + rec.last_name}
                                    </option>
                                  ))}
                                </select>
                                {recruiter && (
                                  <div className="text-end mt-3">
                                    <button
                                      disabled={is_active === 0}
                                      className="btn btn-btn1 btn-btn"
                                      onClick={handleSave}
                                    >
                                      Save
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            {assignedRecruiters.length > 0 && (
                              <div className="crmPost mt-3 tableouter">
                                <div className="table-responsive ">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th style={{ width: "50px" }}>#</th>
                                        <th>Recruiter</th>
                                        <th
                                          style={{
                                            textAlign: "left",
                                            width: "145px",
                                          }}
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                    </thead>
                                    {assignedRecruiters.map((rec, index) => (
                                      <tbody>
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>
                                            {rec.first_name +
                                              " " +
                                              rec.last_name}
                                          </td>
                                          <td>
                                            <Switch
                                              className="switch_case"
                                              handleDiameter={16}
                                              disabled={is_active === 0}
                                              height={18}
                                              width={40}
                                              checked={rec.is_active}
                                              onChange={(checked) => {
                                                handleRemove(rec.id, checked);
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    ))}
                                  </table>
                                </div>
                              </div>
                            )}
                          </TabPanel>
                          <TabPanel>
                            <div className="row">
                              <div className="col-md-12">
                                <label className="form-label">
                                  Managers :{" "}
                                </label>
                                <select
                                  className="form-control col-md-7"
                                  style={{ fontSize: "14px" }}
                                  onChange={(e) => setManager(e.target.value)}
                                  value={manager}
                                >
                                  <option value="">Select a Manager</option>
                                  {managers.map((rec) => (
                                    <option key={rec.id} value={rec.id}>
                                      {`${rec.first_name} ${rec.last_name}`}
                                    </option>
                                  ))}
                                </select>
                                {manager && (
                                  <div className="text-end mt-3">
                                    <button
                                      disabled={is_active === 0}
                                      className="btn btn-btn1 btn-btn"
                                      onClick={handleManagerSave}
                                    >
                                      Save
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            {assignedManagers.length > 0 && (
                              <div className="crmPost mt-3 tableouter">
                                <div className="table-responsive ">
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th style={{ width: "50px" }}>#</th>
                                        <th>Manager</th>
                                        <th
                                          style={{
                                            textAlign: "left",
                                            width: "145px",
                                          }}
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                    </thead>
                                    {assignedManagers.map((rec, index) => (
                                      <tbody>
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>{`${rec.first_name} ${rec.last_name}`}</td>
                                          <td>
                                            <Switch
                                              className="switch_case"
                                              handleDiameter={16}
                                              height={18}
                                              width={40}
                                              disabled={is_active === 0}
                                              checked={rec.is_active}
                                              onChange={(checked) => {
                                                handleManagerRemove(
                                                  rec.reportingManagers_id,
                                                  checked
                                                );
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    ))}
                                  </table>
                                </div>
                              </div>
                            )}
                          </TabPanel>
                        </Tabs>
                      </div>
                    </div>
                  </div>
                </div>
                <Tabs>
                  <TabList>
                    <Tab>Shortlisted <span style={{
                      fontWeight: "bold",
                      color: "#ff6347", fontSize: "1.2em", marginLeft: "5px"
                    }}>({candidates.length})</span></Tab>
                    <Tab>Archived  <span style={{
                      fontWeight: "bold",
                      color: "#ff6347", fontSize: "1.2em", marginLeft: "5px"
                    }}>({archiveList.length})</span></Tab>
                    <Tab>Applied <span style={{
                      fontWeight: "bold",
                      color: "#ff6347", fontSize: "1.2em", marginLeft: "5px"
                    }}>({appliedList.length})</span></Tab>
                    {/* <Tab>Selected <span style={{
                      fontWeight: "bold",
                      color: "#ff6347", fontSize: "1.2em", marginLeft: "5px"
                    }}>( {hiredList.length})</span></Tab> */}
                    <Tab>Reject <span style={{
                      fontWeight: "bold",
                      color: "#ff6347", fontSize: "1.2em", marginLeft: "5px"
                    }}>({RejectList.length})</span></Tab>
                    <Tab>On Hold <span style={{
                      fontWeight: "bold",
                      color: "#ff6347", fontSize: "1.2em", marginLeft: "5px"
                    }}>({OnholdList.length})</span></Tab>
                    <Tab>Recruit <span style={{
                      fontWeight: "bold",
                      color: "#ff6347", fontSize: "1.2em", marginLeft: "5px"
                    }}>({hiredList.length})</span></Tab>
                  </TabList>
                  <TabPanel>
                    <ShortlistTable
                      candidates={candidates}
                      formatDateToCustomFormat={formatDateToCustomFormat}
                      candidateInterview={candidateInterview}
                      goToEditPage={goToEditPage}
                      jobOpeningId={location.state.props.id}
                      getShortList={getShortList}
                      getHiredList={getHiredList}
                      getArchivedList={getArchivedList}
                      OnholdList={onHoldcandidateList}
                      RejectList={RejectListcandidateList}
                      RecruitList={RecruitListListcandidateList}
                      StatusValues={StatusValues}
                      userList={userList}
                      is_active={is_active}
                    />
                  </TabPanel>
                  <TabPanel>
                    <ArchiveListTable
                      candidates={archiveList}
                      formatDateToCustomFormat={formatDateToCustomFormat}
                      candidateInterview={candidateInterview}
                      goToEditPage={goToEditPage}
                      jobOpeningId={location.state.props.id}
                      getShortList={getShortList}
                      getHiredList={getHiredList}
                      getArchivedList={getArchivedList}
                      OnholdList={onHoldcandidateList}
                      RejectList={RejectListcandidateList}
                      RecruitList={RecruitListListcandidateList}
                      StatusValues={StatusValues}
                      userList={userList}
                      is_active={is_active}
                    />
                  </TabPanel>
                  <TabPanel>
                    <AppliedListTable
                      candidates={appliedList}
                      formatDateToCustomFormat={formatDateToCustomFormat}
                      candidateInterview={candidateInterview}
                      goToEditPage={goToEditPage}
                      jobId={location.state.props.id}
                      getShortList={getShortList}
                      OnholdList={onHoldcandidateList}
                      RejectList={RejectListcandidateList}
                      RecruitList={RecruitListListcandidateList}
                      StatusValues={StatusValues}
                      userList={userList}
                      is_active={is_active}
                    />
                  </TabPanel>
                  {/* <TabPanel>
                    <HiredTable
                      candidates={hiredList}
                      formatDateToCustomFormat={formatDateToCustomFormat}
                      candidateInterview={candidateInterview}
                      goToEditPage={goToEditPage}
                      jobOpeningId={location.state.props.id}
                      getHiredList={getHiredList}
                      StatusValues={StatusValues}
                      userList={userList}
                      is_active={is_active}
                    />
                  </TabPanel> */}
                  <TabPanel>
                    <RejectTable
                      candidates={RejectList}
                      formatDateToCustomFormat={formatDateToCustomFormat}
                      candidateInterview={candidateInterview}
                      goToEditPage={goToEditPage}
                      jobId={location.state.props.id}
                      getShortList={getShortList}
                      getHiredList={getHiredList}
                      getArchivedList={getArchivedList}
                      OnholdList={onHoldcandidateList}
                      RejectList={RejectListcandidateList}
                      RecruitList={RecruitListListcandidateList}
                      StatusValues={StatusValues}
                      userList={userList}
                      is_active={is_active}
                    />
                  </TabPanel>
                  <TabPanel>
                    <OnHoldTable
                      candidates={OnholdList}
                      formatDateToCustomFormat={formatDateToCustomFormat}
                      candidateInterview={candidateInterview}
                      goToEditPage={goToEditPage}
                      jobId={location.state.props.id}
                      getShortList={getShortList}
                      getHiredList={getHiredList}
                      getArchivedList={getArchivedList}
                      OnholdList={onHoldcandidateList}
                      RejectList={RejectListcandidateList}
                      RecruitList={RecruitListListcandidateList}
                      StatusValues={StatusValues}
                      userList={userList}
                      is_active={is_active}
                    />
                  </TabPanel>
                  <TabPanel>
                    <RecruitTable
                      //  candidates={RecruitList}
                      candidates={hiredList}
                      formatDateToCustomFormat={formatDateToCustomFormat}
                      candidateInterview={candidateInterview}
                      goToEditPage={goToEditPage}
                      jobId={location.state.props.id}
                      getShortList={getShortList}
                      getHiredList={getHiredList}
                      getArchivedList={getArchivedList}
                      OnholdList={onHoldcandidateList}
                      RejectList={RejectListcandidateList}
                      RecruitList={RecruitListListcandidateList}
                      StatusValues={StatusValues}
                      userList={userList}
                      is_active={is_active}
                    />
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
          {scheduleInterview && (
            <ScheduleInterviewPopup
              onClose={closePopup}
              candidateId={candidateId}
              opening={opening}
            />
          )}
          <button
            type="button"
            className="floating-back-button"
            onClick={handleBack}
          >
            <BsArrowLeftCircleFill size={24} />
          </button>
        </div>
      </div>
    </>
  );
}

export default AssignRecruiter;
